import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const OrganisationBypassPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/organisation/locations')
  }, [])
  return (
    <>
    </>
  )
}